"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SwapLeftOutline = {
    name: 'swap-left',
    theme: 'outline',
    icon: {
        tag: 'svg',
        attrs: { viewBox: '0 0 1024 1024', focusable: false },
        children: [
            {
                tag: 'path',
                attrs: {
                    d: 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'
                }
            }
        ]
    }
};
exports.default = SwapLeftOutline;
